import type { ErrorComponentProps } from '@tanstack/react-router';
import { useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GlobalError } from '@/components/common/error/GlobalError';
import { PERMISSION_DENIED } from '@/lib/hooks/common/usePermissions';
import { DefaultError } from './DefaultError';

export const RouteErrorComponent = ({ error }: ErrorComponentProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const isPermissionError = error?.message === PERMISSION_DENIED;

  if (isPermissionError) {
    return (
      <DefaultError
        title={t(($) => $.common.errors.permission.title)}
        description={t(($) => $.common.errors.permission.description)}
        actions={[
          {
            label: t(($) => $.common.goBack),
            action: () => {
              if (router.history.canGoBack()) {
                router.history.back();
              } else {
                router.navigate({ to: '/' });
              }
            },
          },
        ]}
      />
    );
  }

  return <GlobalError error={error} />;
};
